import React from 'react';
import BBBSeal from './BBBSeal';

const Footer: React.FC = () => {
  return (
    <footer className="new-footer">
      <div className="footer-container">
        {/* Left Column - Newsletter */}
        <div className="footer-column footer-newsletter">
          <h3 className="footer-title">Get the latest from Alert1.</h3>
          <form className="newsletter-form">
            <input 
              type="email" 
              placeholder="Email address" 
              className="newsletter-input"
            />
            <button type="submit" className="newsletter-submit">→</button>
          </form>
          <div className="social-icons">
            <a href="https://www.facebook.com/AlertOne/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
              </svg>
            </a>
            <a href="https://x.com/Alert1MedAlert" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X (Twitter)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/user/alert1tv" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/alert1/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Middle Column - Links */}
        <div className="footer-column footer-links">
          <nav className="footer-nav">
            <a href="/medical-alerts" className="footer-link">Shop Medical Alerts</a>
            <a href="/my-account" className="footer-link">My Account</a>
            <a href="/compare" className="footer-link">Compare Life Alert Costs <sup>1</sup></a>
            <a href="/blog" className="footer-link">Blog</a>
            <a href="/reviews" className="footer-link">Alert1 Reviews</a>
          </nav>
          <p className="footer-disclaimer">
            <sup>1</sup> Life Alert® is a registered trademark of Life Alert Emergency Response, Inc.
          </p>
        </div>

        {/* Right Column - Contact */}
        <div className="footer-column footer-contact">
          <h3 className="footer-title">Need a hand?</h3>
          <p className="contact-text">
            To become a Member, please call our <strong>Sales Team</strong> at{' '}
            <a href="tel:1-877-579-9862" className="contact-phone">(1-877-579-9862)</a> ext 1<br />
            <span className="contact-hours">Monday - Friday from 9:00 AM – 8 PM E.T.<br />
            Saturday from 9:00 AM – 5:30 PM E.T.</span>
          </p>
          
          <p className="contact-text">
            For current Members who need <strong>Technical Support</strong>, please call{' '}
            <a href="tel:1-877-579-9862" className="contact-phone">(1-877-579-9862)</a> ext 3
          </p>
          
          <p className="contact-text">
            For current Members who need general assistance, please call{' '}
            <strong>Member Care</strong> at{' '}
            <a href="tel:1-877-579-9862" className="contact-phone">(1-877-579-9862)</a> ext 2<br />
            <span className="contact-hours">Monday - Friday from 9:00 AM - 5:30 PM E.T.</span>
          </p>

          <div className="contact-icons">
            <a href="/faq" className="contact-icon-link">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" className="contact-icon">
                <circle cx="20" cy="20" r="16" stroke="currentColor" strokeWidth="2"/>
                <text x="20" y="28" fontSize="24" fontWeight="bold" textAnchor="middle" fill="currentColor">?</text>
              </svg>
              <span>FAQ</span>
            </a>
            <a href="mailto:membercare@alert1.com" className="contact-icon-link">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" className="contact-icon">
                <rect x="5" y="10" width="30" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M5 10l15 12 15-12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Email</span>
            </a>
            <a href="tel:1-877-579-9862" className="contact-icon-link">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" className="contact-icon">
                <rect x="12" y="8" width="16" height="24" rx="2" stroke="currentColor" strokeWidth="2"/>
                <circle cx="20" cy="27" r="1.5" fill="currentColor"/>
                <line x1="15" y1="11" x2="25" y2="11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>Call</span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="copyright">©1988-2025 AlertOne Services, LLC.</p>
          <div className="footer-bbb">
            <BBBSeal variant="slim" />
          </div>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <span> | </span>
            <a href="/terms">Terms & Conditions of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

